export const STORE_ALL_LAW_EVENT = 'STORE_ALL_LAW_EVENT';
export const STORE_ALL_SEARCH_EVENT = 'STORE_ALL_SEARCH_EVENT';
export const GET_SUB_CATEGORIES = 'GET_SUB_CATEGORIES';
export const STORE_START_EVENT = 'STORE_START_EVENT';
export const STORE_ALL_ACTIVE_EVENT = 'STORE_ALL_ACTIVE_EVENT';
export const STORE_ALL_COMPLETED_EVENT = 'STORE_ALL_COMPLETED_EVENT';
export const START_LOADING = 'START_LOADING';
export const STORE_EVENT_ASSOCIATION = 'STORE_EVENT_ASSOCIATION';
export const STORE_EVENT_MASTER = 'STORE_EVENT_MASTER';
